import { type PrimitiveProps } from '@react-three/fiber';
import { type IPhoneProModel, GLTFModel } from '@billykwok/3d';

import { AnimatedPrimitive } from '@/utils/react-three-fiber/animations';
import { useGLTF } from '@/utils/react-three-fiber/useGLTF';

const modelPath = `/models/${GLTFModel.IPhonePro}`;

export function AnimatedIPhonePro(props: Partial<PrimitiveProps>) {
  const { scene } = useGLTF<IPhoneProModel, string>(modelPath);
  return <AnimatedPrimitive object={scene} dispose={null} {...props} />;
}

useGLTF.preload(modelPath);
